import React from 'react'
import { List as UIList } from '@faststore/ui'

import type { ValuesObjectProps } from '../../types'
import type { FilterQuantityProps } from '../../types/components/FilterQuantity'
import FilterItem from './components/FilterItem'
import FilterItemWithImage from './components/FilterItemWithImage'
import listWithImages from './data/listWithImages.json'

export interface IListWithImages {
  [key: string]: string
}

export default function FilterQuantity({
  values,
  testId,
  label,
  selectedFacets,
  keyValue,
  testFacets,
  onFacetChange,
  isFallbackImgFilter,
  setIsFallbackImgFilter,
}: FilterQuantityProps) {
  const ListKeysWithImages = listWithImages as IListWithImages
  const isRenderBigImages = ListKeysWithImages?.[keyValue]

  return (
    <>
      <UIList>
        {values?.map((item: ValuesObjectProps) => {
          const id = `${testId}-${label}-${item?.label}`

          return (
            <li
              key={id}
              className={`filter__item ${
                isRenderBigImages ? 'filter__item-withImage' : ''
              }`}
            >
              {!isRenderBigImages ? (
                <FilterItem
                  id={id}
                  itemValues={item}
                  testId={testId}
                  label={label}
                  selectedFacets={selectedFacets}
                  keyValue={keyValue}
                  testFacets={testFacets}
                  onFacetChange={onFacetChange}
                  isFallbackImgFilter={isFallbackImgFilter}
                  setIsFallbackImgFilter={setIsFallbackImgFilter}
                />
              ) : (
                <FilterItemWithImage
                  id={id}
                  itemValues={item}
                  testId={testId}
                  selectedFacets={selectedFacets}
                  keyValue={keyValue}
                  testFacets={testFacets}
                  onFacetChange={onFacetChange}
                />
              )}
            </li>
          )
        })}
      </UIList>
    </>
  )
}
